import { useEffect, useRef, useState } from "react";
import { Button, FloatingIndicator } from "@mantine/core";
import styled from "styled-components";

type TabControlProps = {
  activeTab: string;
  setActiveTab: any;
};

const CalendarTabControls = ({ activeTab, setActiveTab }: TabControlProps) => {
  const rootRef = useRef<HTMLDivElement | null>(null);
  const buttonRefs = useRef<Record<string, HTMLButtonElement | null>>({});

  const [indicatorTarget, setIndicatorTarget] = useState<HTMLElement | null>(
    null
  );

  const data = [
    { key: "shift-plan", label: "İşgücü Planlama" },
    { key: "employee-assign", label: "Çalışan Atama" },
  ];

  const setRef = (key: string) => (el: HTMLButtonElement | null) => {
    buttonRefs.current[key] = el;
  };

  useEffect(() => {
    const target = buttonRefs.current[activeTab];
    if (target) {
      setIndicatorTarget(target);
    }
  }, [activeTab]);

  return (
    <ControlWrapper ref={rootRef}>
      {data.map((tab) => (
        <ControlButton
          key={tab.key}
          $active={activeTab === tab.key}
          ref={setRef(tab.key)}
          onClick={() => {
            setActiveTab(tab.key);
          }}
          variant="subtle"
        >
          <span
            style={{
              zIndex: "5",
            }}
          >
            {tab.label}
          </span>
        </ControlButton>
      ))}

      {indicatorTarget && rootRef.current && (
        <Indicator target={indicatorTarget} parent={rootRef.current} />
      )}
    </ControlWrapper>
  );
};

export default CalendarTabControls;

const ControlWrapper = styled.div`
  position: relative;
  background-color: #f6f5fa;
  width: fit-content;
  border-radius: 50px;
  padding: 5px;
  border: 1px solid #e5e7eb;
  display: flex;
  gap: 8px;
`;

const ControlButton = styled<any>(Button)<{ $active: boolean }>`
  font-weight: 500;
  background-color: transparent;
  &:hover {
    background: unset;
    color: unset;
  }
  span {
    color: ${({ $active }) => ($active ? "white" : "black")};
  }
`;

const Indicator = styled(FloatingIndicator)`
  background-color: #5c26ff;
  border-radius: 50px;
`;
